<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Calls</span>
      <span class="api-card__desc">Audit log of API calls across all organizations.</span>
    </div>
  </div>


  <div class="admin-table-scroll">
    <table class="billing-table admin-stack admin-stack--calls-preview">
      <thead>
        <tr>
          <th>Organization</th>
          <th>Endpoint</th>
          <th>Status</th>
          <th class="col-num">Latency</th>
        </tr>
      </thead>
      <tbody>
        @if (isLoading) {
          @for (i of [1,2,3,4]; track i) {
            <tr>
              <td><app-skeleton width="65%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="80%" height="14px"></app-skeleton></td>
              <td><app-skeleton width="40px" height="20px" radius="4px"></app-skeleton></td>
              <td><app-skeleton width="50px" height="14px"></app-skeleton></td>
            </tr>
          }
        } @else {
          @for (row of rows; track row.id) {
            <tr>
              <td>{{ row.organization.name }}</td>
              <td class="cell-endpoint"><span class="cell-endpoint__method">{{ row.method }}</span> /{{ row.endpoint }}</td>
              <td>
                @if (row.error) {
                  <span class="txn-status-badge txn-status-badge--error">{{ row.status }}</span>
                } @else {
                  <span class="cell-status--ok">{{ row.status }}</span>
                }
              </td>
              <td class="col-num" [class.cell-latency--slow]="isSlow(row)">{{ row.latencyMs | latency }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="api-card__footer">
    <a routerLink="/admin/calls" class="link">
      View all calls
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
